import { Card, CardContent, CardHeader, CardTitle } from "@nimit9/signet-ui/components/card"
import { ThemeToggle } from "@nimit9/signet-ui/components/theme-toggle"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/appearance")({
  component: AppearanceTab,
})

function AppearanceTab() {
  return (
    <div className="max-w-2xl space-y-4">
      {/* Theme card */}
      <Card>
        <CardHeader className="border-b border-border-subtle px-5 py-4">
          <CardTitle className="text-[14px] font-semibold text-text-primary">Theme</CardTitle>
        </CardHeader>
        <CardContent className="px-5 py-2">
          <ThemeToggle showLabels />
        </CardContent>
      </Card>
    </div>
  )
}
